export default "__VITE_ASSET__BowVArEg__"